import React from "react";
import SvgFrag from "./../../images/frag-axe.svg"
import ImageFrag2 from "./../../images/A5xF1 e010947394-v8.jpg"
import ImageFrag3 from "./../../images/A5xF2 a023405.jpg"
import ImageFrag4 from "./../../images/A5xF3.png"
import ImageFrag5 from "./../../images/A5xF4.png"
import ImageFrag1 from "./../../images/fragment-manquant.svg"

const openModal = (ev) => {
    console.log('test');
    var target = ev.target;
    if (target.classList.contains('frag--container')){
    } else if (target.parentNode.classList.contains('frag--container')){
        target = target.parentNode;
    } else if (target.parentNode.parentNode.classList.contains('frag--container')){
        target = target.parentNode.parentNode;
    } else if (target.parentNode.parentNode.parentNode.classList.contains('frag--container')){
        target = target.parentNode.parentNode.parentNode;
    }
    target.classList.toggle('show');
}

export default () => (
  <div className="frag--wrapper">
      <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F1</span>
        <div className="frag--modal missing">
            <div className="frag--content">
                <ImageFrag1/>
                <span>Un père Jésuite et un chef huron en exil discutent. Photographe inconnu, sans date.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F2</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag2} alt=""/>
                <span>Trois Chefs des Premières Nations en habits hurons. Dessin de Edward Chatfield, Peter Winkworth Collection, BAC, 1825.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F3</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag3} alt=""/>
                <span>Groupe d&#39;Indiens au Village Huron. Photographie de Jules-Ernest Livernois. Collection J.E. Livernois, BAC, ca1900.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F4</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag4} alt=""/>
                <span>Église Jeune-Lorette du Village Huron. Photographie de Claude Gaboury, Fond du Ministère des Communications, BAnQ, 1977.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F5</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag5} alt=""/>
                <span>La fabrication de raquettes au Village Huron. Photographie de Bernard Vallée, Fond du Ministère des Communications, BAnQ, 1976.</span>
            </div>
        </div>
     </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/frag-axe5.js